import { Clients } from "./Clients";

export const environment = {
 production: false,
  client: Clients.NEPAL_BANK_LIMITED,
  appConfigStorageKey: "QP'`0t=Wf_(yB?ni^(*rv0gB].ck$s@z(/SB_PK",
  appConfigName: '@sb_product_creditx_automation',
  appName: 'creditx_automation',
  bankName: 'NEPAL BANK LIMITED',

  baseApiUrl: 'https://plus-backend.mbank.com.np',
  baseApiUrlV2: 'https://plus-backend.mbank.com.np/v2',
  socketUrl: 'https://plus-socket.mbank.com.np',


  productName: 'creditx_automation',
  productSlogan: ' - CreditX Loan Automation System | Digital Solutions for Your Workstation',
  SBS_GROUP: false,
  pwa: false,
  disableCrgAlpha: false,
  disableCrgLambda: false,
  small_logo_path: 'assets/images/mbank1.png',
  large_logo_path: 'assets/images/mbank1.png',
};
